var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler 
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};


// $(document).on('click', '.js-cart-remove-bundle1', function (e) {
//     e.preventDefault();
//     let class_name = $(this).attr('data-class');
//     let isCart = $(this).attr('data-cart');
//     let current_item = {};
//     $('.' + class_name).each(function () {
//        var key = $(this).attr('data-key');
//        var qty = 0;
//        current_item[key] = qty;
//     });

     
//     $.ajax({
//        url: "/cart/update.js",
//        data: {
//           'updates': current_item
//        },
//        method: "POST",
//        dataType: "JSON",
//        success: function (data) {

//         $('#cart-drawer').click().trigger("click");
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                        bubbles: true
//                    }));
//          alert('remvoe');
//        },
//        error: function (error) {
//           console.log(error)
//        }
//     });
//  });

$(document).on('click', '.js-cart-remove-bundle1', function(e) {

    e.preventDefault();

    let class_name = $(this).attr('data-class');
    let isCart = $(this).attr('data-cart');

    let current_item = {};
    $('.' + class_name).each(function() {
        var key = $(this).attr('data-key');
        var qty = 0;
        current_item[key] = qty;
    });

    $.ajax({
        url: "/cart/update.js",
        data: {
            'updates': current_item
        },
        method: "POST",
        dataType: "JSON",
        success: function(data) {
            removeGiftProduct();
            console.log("REMOVED");
            if (isCart == 'true') {
                window.location = '/cart';
            } else {
                $('#cart-drawer').click().trigger("click");
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }
        },
        error: function(error) {
            console.log(error)
        }
    });
});

// function addHtmlBlock(parent) {
//     var productId = $(parent.find(`select.actual-variantss option:selected`)).val();
//     var productMainId = $(parent.find(`select.actual-variantss`)).attr('data-pro-id');
//     var productImg = $(parent.find(`select.actual-variantss option:selected`)).attr('data-image');
//     var productTitle = $(parent.find(`select.actual-variantss option:selected`)).attr('data-product-title');
//     var productVarTitle = $(parent.find(`select.actual-variantss option:selected`)).attr('data-var-title');
//     var productPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-price');
//     var productComPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-compareat-price');
//     var withoutMoneyPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-without-money_formate');


//     var existingProduct = $('.cw-product-bundle__summary-product-block[data-pro-id="' + productMainId + '"]');


//     var currentQty = existingProduct.length > 0 ? existingProduct.find('.js_qtybox').val() : 1;

//     var newProductBlock = `
//   <div class="cw-product-bundle__summary-product-block js_product_box eq-bundle--parent" data-pro-id="${productMainId}"  data-var-id="${productId}">
//     <a href="javascript:;" class="cw-product-bundle__summary-product-remove">
//       <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M13.125 7.875L7.875 13.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
//         <path d="M7.875 7.875L13.125 13.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
//       </svg>
//     </a>
//     <div class="cw-product-bundle__summary-product-image">
//       <img src="${productImg}" alt="summary Product image">
//     </div>
//     <div class="cw-product-bundle__summary-product-detail">
//       <div class="cw-product-bundle__summary-product-info">
//         <h5 class="cw-product-bundle__summary-product-title">${productTitle} </h5>
//         <p>${productVarTitle}</p>
//         <span class="cw-product-bundle__summary-product-price">
//           <span class="cw-product-bundle__sale-price cw-product-bundle__summary-money">${productPrice}</span>
//           <del class="cw-product-bundle__compare-price cw-product-bundle__summary-money">${productComPrice}</del>
//         </span>
//       </div>
//       <div class="cw-product-bundle__summary-product-qty">
//         <div class="cw-product-bundle__qty-block">
//           <div class="cw-product-bundle__product-qty">
//             <button class="cw-product-bundle__button bundle_box_minus1">
//               <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
//                 <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
//               </svg>
//             </button>
//             <input type="number" class="cw-product-bundle__input-qty js_qtybox" data-pro-price="${withoutMoneyPrice}" data-pro-id="${productMainId}"  value="${currentQty}" data-id="${productId}" min="1">
//             <button class="cw-product-bundle__button bundle_box_plus bundle_box_plus_${productMainId}">
//               <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
//                 <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// `;

//     // if (existingProduct.length > 0) {
//     //     existingProduct.replaceWith(newProductBlock);
//     // } else {  }
//     $('.cw-product-bundle__summary-product-wrapper').append(newProductBlock);

//     calculateTotal();
//     return false;
// }

function addHtmlBlock(parent) {
	var productId = $(parent.find(`select.actual-variantss option:selected`)).val();
	var productMainId = $(parent.find(`select.actual-variantss`)).attr('data-pro-id');
	var productImg = $(parent.find(`select.actual-variantss option:selected`)).attr('data-image');
	var productTitle = $(parent.find(`select.actual-variantss option:selected`)).attr('data-product-title');
	var productVarTitle = $(parent.find(`select.actual-variantss option:selected`)).attr('data-var-title');
	var productPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-price');
	var productComPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-compareat-price');
	var withoutMoneyPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-without-money_formate');
  
	// Check if a product with the same data-var-id already exists
	var existingProduct = $('.cw-product-bundle__summary-product-block[data-pro-id="' + productMainId + '"]');
	
	// Retrieve the current quantity from the existing product block if it exists
	var currentQty = existingProduct.length > 0 ? existingProduct.find('.js_qtybox').val() : 1; // Default to 1 if it doesn't exist
  
	var newProductBlock = `
	<div class="cw-product-bundle__summary-product-block js_product_box eq-bundle--parent" data-pro-id="${productMainId}"  data-var-id="${productId}">
	  <a href="javascript:;" class="cw-product-bundle__summary-product-remove">
		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M13.125 7.875L7.875 13.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
		  <path d="M7.875 7.875L13.125 13.125" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
		</svg>
	  </a>
	  <div class="cw-product-bundle__summary-product-image">
		<img src="${productImg}" alt="summary Product image">
	  </div>
	  <div class="cw-product-bundle__summary-product-detail">
		<div class="cw-product-bundle__summary-product-info">
		  <h5 class="cw-product-bundle__summary-product-title">${productTitle} </h5>
		  <p>${productVarTitle}</p>
		  <span class="cw-product-bundle__summary-product-price">
			<span class="cw-product-bundle__sale-price cw-product-bundle__summary-money">${productPrice}</span>
			<del class="cw-product-bundle__compare-price cw-product-bundle__summary-money">${productComPrice}</del>
		  </span>
		</div>
		<div class="cw-product-bundle__summary-product-qty">
		  <div class="cw-product-bundle__qty-block">
			<div class="cw-product-bundle__product-qty">
			  <button class="cw-product-bundle__button bundle_box_minus1">
				<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
				  <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
				</svg>
			  </button>
			  <input type="number" class="cw-product-bundle__input-qty js_qtybox" data-pro-price="${withoutMoneyPrice}" data-pro-id="${productMainId}"  value="1" data-id="${productId}" min="1">
			  <button class="cw-product-bundle__button bundle_box_plus bundle_box_plus_${productMainId}">
				<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
				  <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
				</svg>
			  </button>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  `;
  
	// if (existingProduct.length > 0) {
	// 	// If exists, replace the existing product block
	// 	existingProduct.replaceWith(newProductBlock);
	// } else {}
		// If it doesn't exist, append the new product block
		$('.cw-product-bundle__summary-product-wrapper').append(newProductBlock);
	
	calculateTotal();
	return false;
  }

$(document).on('click', '.js_qtybox', function(e) {
    e.preventDefault();
    var updatedQty = $(this).val();
    var productMainId = $(this).closest('.cw-product-bundle__summary-product-block').attr('data-pro-id');
    var sameProductBlocks = $('.cw-product-bundle__summary-product-block.js_product_box[data-pro-id="' + productMainId + '"]');
    sameProductBlocks.find('.cw-product-bundle__input-qty').val(updatedQty);
});
$(document).on('click', '.cw-product-bundle__btn-add', function(e) {
  e.preventDefault();
  function containsScrunchiesOrTies() {
    // Select all matching <p> elements
    const paragraphs = document.querySelectorAll('div.cw-product-bundle__summary-product-detail > div.cw-product-bundle__summary-product-info > p');
    const headers = document.querySelectorAll('div.cw-product-bundle__summary-product-detail > div.cw-product-bundle__summary-product-info > h5');
    // Loop over each <p> element
    for (let paragraph of paragraphs) {
        const textContent = paragraph.textContent.toLowerCase();
        
        // Check if the paragraph text contains "scrunchies" or "ties"
        if (textContent.includes('scrunchies') || textContent.includes('ties')) {
            return true; // Return true if either word is found
        }
    }
    for (let header of headers) {
        const textContent = header.textContent.toLowerCase();
        
        // Check if the paragraph text contains "scrunchies" or "ties"
        if (textContent.includes('scrunchies') || textContent.includes('ties')) {
            return true; // Return true if either word is found
        }
    }

    // Return false if no match is found
    return false;
}
    
    let parent = $(e.target).closest('.eq-bundle--parent');
    let variantPrice = $(parent.find(`select.actual-variantss option:selected`)).attr('data-without-money_formate');
    let proVarId = $(parent.find(`select.actual-variantss option:selected`)).val();
    $(parent.find(`.cw-product-bundle__input-qty`)).attr('data-var-price', variantPrice);
    //$(parent.find(`.cw-product-bundle__input-qty`)).attr('data-pro-price', variantPrice);
    parent.attr('data-var-id', proVarId);
    calculateTotal();
    addHtmlBlock(parent);
    addTobagDisbled();
    totalQtyCount();

});

$(document).on('click', '.cw-product-bundle__summary-product-remove', function(e) {
    e.preventDefault();
    var productBlock = $(this).closest('.cw-product-bundle__summary-product-block');
    var productMainId = productBlock.attr('data-var-id');
    productBlock.remove();
    var sameProductBlocks = $('.cw-product-bundle__summary-product-block.js_product_box[data-var-id="' + productMainId + '"]');
    var productQty = $('.cw-product-bundle__product-block.eq-bundle--parent[data-var-id="' + productMainId + '"] .cw-product-bundle__product-qty');
    if (sameProductBlocks.length === 0) {
        productQty.hide();
        $('.cw-product-bundle__product-block.eq-bundle--parent[data-var-id="' + productMainId + '"] .cw-product-bundle__btn-add').show();
        productQty.removeAttr('data-var-price');
        productQty.attr('data-visible', '');
    }

  
 


    calculateTotal();
    addTobagDisbled();
    totalQtyCount();
});

function updateQuantity(operation, element) {
    var product_id = $(element).closest('.cw-product-bundle__product-qty').find('.cw-product-bundle__input-qty').attr('data-id');
    var productVarPrice = parseFloat($(element).closest('.cw-product-bundle__product-qty').find('.cw-product-bundle__input-qty').attr('data-var-price'));
    let inputs = $('.cw-product-bundle__input-qty[data-id="' + product_id + '"]');
    inputs.each(function() {
        let currentValue = parseInt($(this).val(), 10);
        if (isNaN(currentValue)) {
            console.warn("Current value is not a number. Resetting to 0.");
            currentValue = 0;
        }
        if (operation === 'plus') {
            currentValue += 1;
        } else if (operation === 'minus' && currentValue > 1) {
            currentValue -= 1;
        } else {
          var sameProductBlocks = $('.cw-product-bundle__summary-product-block.js_product_box[data-var-id="' + product_id + '"]');
          sameProductBlocks.remove();
          var productQty = $('.cw-product-bundle__product-block.eq-bundle--parent[data-var-id="' + product_id + '"] .cw-product-bundle__product-qty');
          if (sameProductBlocks.length === 0) {
              productQty.hide();
              $('.cw-product-bundle__product-block.eq-bundle--parent[data-var-id="' + product_id + '"] .cw-product-bundle__btn-add').show();
              productQty.removeAttr('data-var-price');
              productQty.attr('data-visible', '');
          }
          calculateTotal();
          addTobagDisbled();
          totalQtyCount();
        }


        $(this).val(currentValue);
        let productTotal = currentValue * productVarPrice;
        $(this).closest('.cw-product-bundle__product-qty').find('.product-total').html(productTotal.toFixed(2)); // Update product-specific total
    });

    calculateTotal();

}

$(document).on('click', '.bundle_box_plus', function(e) {
    e.preventDefault();
    updateQuantity('plus', this);
    addTobagDisbled();
    totalQtyCount();
});


$(document).on('click', '.bundle_box_minus1', function(e) {
    e.preventDefault();
    updateQuantity('minus', this);
    addTobagDisbled();
    totalQtyCount();
});

function addTobagDisbled() {
    let bundleBoxLength = $('.js_product_box ').length;
    let disbledBtnText = $('.cw-product-bundle__add-to-bag').attr('data-btn-empty-text');
    if (bundleBoxLength < 1) {
        $('.cw-product-bundle__add-to-bag').text(disbledBtnText);
        $('.cw-product-bundle__add-to-bag').css('background-color', '#dddddd');
        $('.cw-product-bundle__add-to-bag').css('pointer-events', 'none');
        $('.cw-product-bundle__add-to-bag').css('color', '#767676');
    } else {
        $('.cw-product-bundle__add-to-bag').text('add bundle to bag');
        $('.cw-product-bundle__add-to-bag').css('background-color', '#000000');
        $('.cw-product-bundle__add-to-bag').css('pointer-events', 'all');
        $('.cw-product-bundle__add-to-bag').css('color', '#ffffff');
    }

}

function totalQtyCount() {
    let totalQuantity = 0;
    $('.js_qtybox').each(function() {
        let quantity = parseFloat($(this).val());
        if (!isNaN(quantity)) {
            totalQuantity += quantity;
        }

    });
    $('.cw-product-bundle__bundle-item-count').html(`${totalQuantity} items <span> - add more to save </span>`);


}

let freeShipingThreshold1;
let freeShipingThreshold2;
let freeShipingThreshold3;
let formattedPrice;

function calculateTotal() {

    let overallTotal = 0;

    $('.js_qtybox').each(function() {
        let quantity = $(this).val();
        let price = parseFloat($(this).attr('data-pro-price'));

        if (!isNaN(quantity) && !isNaN(price)) {
            overallTotal += (quantity * price);
        }
    });
   
    formattedPrice = (overallTotal / 100).toFixed(2);
    formattedPrice = formattedPrice.replace(/\.00$/, '');
    let discountPrice1 = $('.js_discountPrice_1').attr("data-dic-price");
    let discountPrice2 = $('.js_discountPrice_2').attr("data-dic-price");
    let discountPrice3 = $('.js_discountPrice_3').attr("data-dic-price");
    let discountPercentage1 = $('.js_discountPrice_1').attr("data-dis-percentage");
    let discountPercentage2 = $('.js_discountPrice_2').attr("data-dis-percentage");
    let discountPercentage3 = $('.js_discountPrice_3').attr("data-dis-percentage");
    let cartCurrency = $('#bundle-builder').attr('data-cart-currency')
    if(cartCurrency == 'USD' || cartCurrency == 'EUR' || cartCurrency == 'GBP'){
    freeShipingThreshold1 = parseFloat(discountPrice1);
    freeShipingThreshold2 = parseFloat(discountPrice2);
    freeShipingThreshold3 = parseFloat(discountPrice3);
    }else{
    freeShipingThreshold1 = parseFloat(discountPrice1 * window.Shopify.currency.rate);
    freeShipingThreshold2 = parseFloat(discountPrice2 * window.Shopify.currency.rate);
    freeShipingThreshold3 = parseFloat(discountPrice3 * window.Shopify.currency.rate);
    }

    let tenPercent = (overallTotal * (discountPercentage1 / 100) / 100).toFixed(2);
    let fifteenPercent = (overallTotal * (discountPercentage2 / 100) / 100).toFixed(2);
    let twentyPercent = (overallTotal * (discountPercentage3 / 100) / 100).toFixed(2);
    let disTenAftPrice = (formattedPrice - tenPercent).toFixed(2);
    let disFifteenAftPrice = (formattedPrice - fifteenPercent).toFixed(2);
    let disTwentyAftPrice = (formattedPrice - twentyPercent).toFixed(2);
    let discountText1 = parseFloat(Math.abs(freeShipingThreshold1 - formattedPrice).toFixed(2));
    let discountText2 = parseFloat(Math.abs(freeShipingThreshold2 - formattedPrice).toFixed(2));
    let discountText3 = parseFloat(Math.abs(freeShipingThreshold3 - formattedPrice).toFixed(2));
    let totalBundlePrice =  (overallTotal / 100).toFixed(2);
    // $('.js_overall_total strong').html(Shopify.formatMoney(overallTotal, $('body').attr('data-money-format')));
    $('.js_overall_total strong').html(`${window.currency}${totalBundlePrice}`);
    // $('.js_discount_price1').html(`<strong> - ${window.currency}${fifteenPercent} (${discountPercentage2}%) </strong>`)
    if (formattedPrice < freeShipingThreshold1) {
        //$('.shippipngPrice1').text(`${window.currency}${discountText1}`);
        //$('.js_save_price').text(Shopify.formatMoney(discountText1, $('body').attr('data-money-format')));
        $('.js_save_price').html(`+ Add another <strong class="shippipngPrice1">${window.currency}${discountText1}</strong> to <strong>Save ${discountPercentage1}%!</strong>`);
    } else {
        $('.offer_box_1').removeClass('cw-product-bundle__summary-offer-active');
    }

    if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold2) {
        $('.js_save_price').html(`+ Add another <strong>${window.currency}${discountText2}</strong> to <strong>Save ${discountPercentage2}%!</strong>`);
        //$('.js_save_price').text(Shopify.formatMoney(discountText2, $('body').attr('data-money-format')));
    } else {
        $('.offer_box_2').removeClass('cw-product-bundle__summary-offer-active');
    }

    if (formattedPrice > freeShipingThreshold1 && formattedPrice > freeShipingThreshold2 && formattedPrice < freeShipingThreshold3) {
        $('.js_save_price').html(`+ Add another <strong>${window.currency}${discountText3}</strong> to <strong>Save ${discountPercentage3}%!</strong>`);

    } else {
        $('.offer_box_3').removeClass('cw-product-bundle__summary-offer-active');
    }
    $('.offer_box_1, .offer_box_2, .offer_box_3').removeClass('cw-product-bundle__summary-offer-active');
    $('.js_discount_price2').hide();
    $('.js_save_price').show();
    if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold2) {

        //$('.js_desk_total span strong').text(`${window.currency} ${disTenAftPrice}`);
        $('.js_desk_total span strong').text(Shopify.formatMoney(disTenAftPrice, $('body').attr('data-money-format')));
        $('.offer_box_1').addClass('cw-product-bundle__summary-offer-active');
        $('.js_discount_price1').show();

        $('.js_discount_price1').html(`<strong> - ${window.currency}${tenPercent} (${discountPercentage1}%) </strong>`);

    } else if (formattedPrice > freeShipingThreshold1 && formattedPrice >= freeShipingThreshold2 && formattedPrice < freeShipingThreshold3) {

        //$('.js_desk_total span strong').text(`${window.currency} ${disFifteenAftPrice}`);
        $('.js_desk_total span strong').text(Shopify.formatMoney(disFifteenAftPrice, $('body').attr('data-money-format')));
        $('.js_discount_price1').show();
        $('.js_discount_price1').html(`<strong> - ${window.currency}${fifteenPercent} (${discountPercentage2}%) </strong>`)
        
        $('.offer_box_2').addClass('cw-product-bundle__summary-offer-active');

    } else if (formattedPrice >= freeShipingThreshold3) {

        //$('.js_desk_total span strong').text(`${window.currency} ${disTwentyAftPrice}`);
        $('.js_desk_total span strong').text(Shopify.formatMoney(disTwentyAftPrice, $('body').attr('data-money-format')));
        $('.js_discount_price1').show();
        $('.js_discount_price1').html(`<strong> - ${window.currency}${twentyPercent} (${discountPercentage3}%) </strong>`)
       
        $('.offer_box_3').addClass('cw-product-bundle__summary-offer-active');
        $('.js_save_price').hide();

    } else {

        $('.js_discount_price2').show();
        $('.js_discount_price1').hide();
        $('.js_desk_total span strong').text(Shopify.formatMoney(overallTotal, $('body').attr('data-money-format')));

    }
    $('.cw-product-bundle__add-to-bag').attr('data-total', overallTotal);

}
let checkInterval = setInterval(() => {
    if (typeof window.currency !== 'undefined') {
        calculateTotal();
        clearInterval(checkInterval); // Stop the interval once the condition is met
    }
}, 100);

setTimeout(() => {
    clearInterval(checkInterval); // Stop the interval after 10 seconds if the condition hasn't been met
}, 10000);

function defaultShowDisPrice() {
    let defaultDiscountPrice1 = $('.js_discountPrice_1').attr("data-dic-price");
    let defaultDiscountPrice2 = $('.js_discountPrice_2').attr("data-dic-price");
    let defaultDiscountPrice3 = $('.js_discountPrice_3').attr("data-dic-price");
    let cartCurrency = $('#bundle-builder').attr('data-cart-currency')
         let countryBaseDisPrice1;  
        let countryBaseDisPrice2; 
        let countryBaseDisPrice3;
        console.log(window.country_currency )
    if(cartCurrency == 'USD' || cartCurrency == 'EUR' || cartCurrency == 'GBP'){
       countryBaseDisPrice1 = parseFloat(defaultDiscountPrice1).toFixed(2);
       countryBaseDisPrice2 = parseFloat(defaultDiscountPrice2).toFixed(2);
        countryBaseDisPrice3 = parseFloat(defaultDiscountPrice3).toFixed(2);  
    }else{
    countryBaseDisPrice1 = parseFloat(defaultDiscountPrice1 * window.Shopify.currency.rate).toFixed(2);
    countryBaseDisPrice2 = parseFloat(defaultDiscountPrice2 * window.Shopify.currency.rate).toFixed(2);
    countryBaseDisPrice3 = parseFloat(defaultDiscountPrice3 * window.Shopify.currency.rate).toFixed(2);
    }   
    setTimeout(function() {}, 2000);

    let currencySymbol = $('#bundle-builder').attr('data-currency-symbol');

    $('.shippipngPrice1').text(`${currencySymbol}${countryBaseDisPrice1}`);
    $('.js_discountPrice_1').html(`Spend ${currencySymbol}${countryBaseDisPrice1}`);
    $('.js_discountPrice_2').html(`Spend ${currencySymbol}${countryBaseDisPrice2}`);
    $('.js_discountPrice_3').html(`Spend ${currencySymbol}${countryBaseDisPrice3}`);

}


$(document).on("click", ".eq-bundle--parent .cw-bundle-products.cw-product-bundle__variant-option", function(e) {

    let option1 = option2 = option3 = null;
    let parent = $(e.target).closest('.eq-bundle--parent');

    var product_id = parent.find(".cw-product-bundle__variant-option").attr('data-value')
    if (parent.find('[data-option-1]').length > 0) {
        option1 = parent.find('.test').val();
    }

    if (parent.find('[data-option-2]').length > 0) {
        option2 = parent.find('[data-option-2] option:selected').val();
    }
    if (parent.find('[data-option-3]').length > 0) {
        option3 = parent.find('[data-option-3] option:selected').val();
    }

    let variant_id = null;
    let current_selected_option = null;

    if (option2 == null & option3 == null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`)).val();
    }
    if (option2 != null & option3 == null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`)).val();
    }
    if (option2 != null & option3 != null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`)).val();
    }
    let price = $(current_selected_option).attr('data-price');
    let comPrice = $(current_selected_option).attr('data-compareat-price');
    let withoutMoneyPrice = $(current_selected_option).attr('data-without-money_formate');

    let is_available = $(current_selected_option).attr('data-available');
    let variantImage = (current_selected_option).data('image');
    $(parent.find(`.cw-product-bundle__plus,.cw-product-bundle__minus`)).attr('data-id', variant_id);
    $(parent.find(`.cw-product-bundle__input-qty`)).attr('data-id', variant_id);
    if (variantImage) {
        $(parent.find(`.our-bestselling-products__box-img img`)).attr('src', variantImage);
    }
    $(parent.find(`select.actual-variantss`)).val(variant_id).trigger('change');

    parent.attr('data-var-id', variant_id);


    // $('.js_qtybox').each(function() {
    //     var dataId = $(this).attr('data-id');
    //     var parent = $(this).closest('.cw-product-bundle'); // Adjust the selector to find the correct parent
        
    //     if (dataId == variant_id) {
    //         parent.find(`.cw-product-bundle__product-qty`).show();
    //         parent.find(`.cw-product-bundle__btn-add`).hide();
    //     } else {
    //         parent.find(`.cw-product-bundle__product-qty`).hide();
    //         parent.find(`.cw-product-bundle__btn-add`).show();
    //     }
    // });
    
    $(parent.find(`.now_price`)).text(price);


    let matchingElements = [];

    $('.js_qtybox').each(function() {
        var dataId = $(this).attr('data-id');
        var currentQty = $(this).val();
        var parent = $(e.target).closest('.eq-bundle--parent');  
    
        // Check if dataId matches variant_id
        if (dataId == variant_id) {
            matchingElements.push({
                element: $(this),      
                parent: parent,
                quantity: currentQty    // Store the current quantity for further use if needed
            });
        } else {
            // Hide quantity selector and show add-to-cart button for non-matching variants
            parent.find(`.cw-product-bundle__product-qty`).hide();
            parent.find(`.cw-product-bundle__btn-add`).show();
        }
    });
    
    // Loop through matching elements array and show/hide elements accordingly
    $.each(matchingElements, function(index, item) {
        // Show the quantity selector and hide the add-to-cart button for matching elements
        item.parent.find(`.cw-product-bundle__product-qty`).show();
        item.parent.find(`.cw-product-bundle__btn-add`).hide();
    
        // Optionally, set the quantity for the matching element if necessary
        //item.element.val(item.quantity); // This sets the visible quantity input value
        parent.find(`.cw-product-bundle__input-qty`).val(item.quantity);
    });
    

    // if ($(parent).find('[data-visible="visible"]').length > 0) {
    //     // There are qty blocks with data-visible set to true

    //     addHtmlBlock(parent);
    // } else {
    //     // No qty blocks with data-visible set to true

    // }
    $(parent.find(`.cw-product-bundle__product-qty`)).attr('data-qty-id', variant_id);
    $(parent.find(`.cw-product-bundle__input-qty`)).attr('data-var-price', withoutMoneyPrice);
    //$(parent.find(`.cw-product-bundle__input-qty`)).attr('data-pro-price', withoutMoneyPrice);
    calculateTotal();
    if (is_available == 'true') {
        $(parent.find(`.cw-product-bundle__btn-add`)).html(`
    <span class="desktop_add-btn">Add to bag</span>
    <span class="mobile_add-btn">add to bag</span>
`);

        $(parent.find(`.cw-product-bundle__btn-add`)).css('pointer-events', 'all');
        $(parent.find(`.cw-product-bundle__btn-add`)).css('opacity', '1');
    } else {
        $(parent.find(`.cw-product-bundle__btn-add`)).text('sold out');
        $(parent.find(`.cw-product-bundle__btn-add`)).css('pointer-events', 'none');
        $(parent.find(`.cw-product-bundle__btn-add`)).css('opacity', '0.5');
    }


    applyImageFilterOnLoad();
    parent.find(".cw-product-bundle__product-image-slider").each(function() {
        var $slider = $(this);
        setTimeout(function() {
            $slider.slick("slickGoTo", 0);
        }, 50);
    });
});



$(document).on("click", ".eq-bundle--parent--single .cw-single-product.cw-product-bundle__variant-option", function(e) {
    var selectedHandle = $(this).data('handle');
    // alert('handle ' + selectedHandle)
  
    let parent = $(e.target).closest('.eq-bundle--parent--single');
    // let variantId = parent.find('select.actual-variantss option:selected').val();

   
  
    //let selectedProductHandle = parent.find('select.actual-variantss option:selected').attr('data-handle');
    let selectedProductHandle = parent.find('cw-single-product').attr('data-handle');
    let variantId = $(this).data('id');
   
    let productTitle = $(this).data('title');
    let productPrice = $(this).data('product-price');
   
    //alert(variantId)

// Fetch product data for the selected product handle
    // $.ajax({
    // url: '/products/'+ selectedHandle +'?view=ajax-bundle',
    // method: 'GET',
    // success: function(response) {
    // //    console.log("AJAX Response:", response);

    //     // Check if response contains the expected HTML structure
    //     var newOptions = $(response).find('.actual-variantss').html();
    //     console.log("New Options Found:", newOptions);
    //     // $('select.testtsfdfd').html(response);
    //     // Ensure newOptions contains options before replacing
    //     if (newOptions.length > 0) {
    //     // Clear existing options and update with new options
    //     $('select.testtsfdfd').html(newOptions);
    //     console.log("Options replaced successfully.");
    //     } else {
    //     console.warn("No options found in the AJAX response.");
    //     }
    // },
    // error: function(xhr, status, error) {
    //     console.error("AJAX Error:", error);
    // }
    // });
    parent.find('.cw-product-bundle__product-title h4').text(productTitle.split(' - ')[0]);
    parent.find('.now_price').html(productPrice);
    console.log(productTitle);
    $.ajax({
        url: '/products/' + selectedHandle + '?view=ajax-bundle',
        method: 'GET',
        success: function(response) {
           // console.log("AJAX Response:", response);
            
            // Use a temporary div to parse the response
            var tempDiv = $('<div>').html(response);
            var newOptions = tempDiv.find('.actual-variantss');
            var productImage = tempDiv.find('.cw-product-bundle__product-image-slider');
            var productImageSlides = tempDiv.find('.cw-product-bundle__product-image-slider .cw-product-bundle__product-image-slide');
            // Reverse the order of the image slides
            var reversedSlides = $(productImageSlides.get().reverse());
            // Debugging output
            // parent.find('.cw-product-bundle__product-image-slider').html(productImage.html());
            
            parent.find('.cw-product-bundle__product-image-slider').html('');
            parent.find('.cw-product-bundle__product-image-slider').slick('unslick');
         
            parent.find('.cw-product-bundle__product-image-slider').html(reversedSlides);
            //parent.find('.cw-product-bundle__product-image-slider').slick();
            parent.find('.cw-product-bundle__product-image-slider').slick({
                dots: true,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                arrows: false,
            });
           
            console.log("Found newOptions:", newOptions.length > 0);
            if (newOptions.length > 0) {
                // console.log("New Options HTML:", newOptions.html());
                // Clear existing options and update with new options
                parent.find('select.testtsfdfd').html(newOptions.html());
                console.log("Options replaced successfully.");
            } else {
                console.warn("No options found in the AJAX response.");
            }
        },
        error: function(xhr, status, error) {
            console.error("AJAX Error:", error);
        }
    });
    
    let option1 = option2 = option3 = null;
    //let parent = $(e.target).closest('.eq-bundle--parent');

    var product_id = parent.find(".cw-product-bundle__variant-option").attr('data-value')
    if (parent.find('[data-option-1]').length > 0) {
        option1 = parent.find('.test').val();
    }

    if (parent.find('[data-option-2]').length > 0) {
        option2 = parent.find('[data-option-2] option:selected').val();
    }
    if (parent.find('[data-option-3]').length > 0) {
        option3 = parent.find('[data-option-3] option:selected').val();
    }

    let variant_id = null;
    let current_selected_option = null;

    if (option2 == null & option3 == null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`)).val();
    }
    if (option2 != null & option3 == null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`)).val();
    }
    if (option2 != null & option3 != null) {

        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`)).val();
    }
    let price = $(current_selected_option).attr('data-price');
    let comPrice = $(current_selected_option).attr('data-compareat-price');
    let withoutMoneyPrice = $(current_selected_option).attr('data-without-money_formate');

    let is_available = $(current_selected_option).attr('data-available');
    let variantImage = (current_selected_option).data('image');
    $(parent.find(`.cw-product-bundle__plus,.cw-product-bundle__minus`)).attr('data-id', variantId);
    $(parent.find(`.cw-product-bundle__input-qty`)).attr('data-id', variantId);
    if (variantImage) {
        $(parent.find(`.our-bestselling-products__box-img img`)).attr('src', variantImage);
    }
    $(parent.find(`select.actual-variantss`)).val(variant_id).trigger('change');

    parent.attr('data-var-id', variantId);

    $(parent.find(`.now_price`)).text(price);

console.log('first ' + variantId)
    let matchingElements = [];

    $('.js_qtybox').each(function() {
        var dataId = $(this).attr('data-id');
        var currentQty = $(this).val();
        var parent = $(e.target).closest('.eq-bundle--parent');  
    
        // Check if dataId matches variant_id
        if (dataId == variantId) {
            matchingElements.push({
                element: $(this),      
                parent: parent,
                quantity: currentQty    // Store the current quantity for further use if needed
            });
        } else {
            // Hide quantity selector and show add-to-cart button for non-matching variants
            parent.find(`.cw-product-bundle__product-qty`).hide();
            parent.find(`.cw-product-bundle__btn-add`).show();
        }
    });
    
    // Loop through matching elements array and show/hide elements accordingly
    $.each(matchingElements, function(index, item) {
        // Show the quantity selector and hide the add-to-cart button for matching elements
        item.parent.find(`.cw-product-bundle__product-qty`).show();
        item.parent.find(`.cw-product-bundle__btn-add`).hide();
    
        // Optionally, set the quantity for the matching element if necessary
        //item.element.val(item.quantity); // This sets the visible quantity input value
        parent.find(`.cw-product-bundle__input-qty`).val(item.quantity);
    });
    

    // if ($(parent).find('[data-visible="visible"]').length > 0) {
    //     // There are qty blocks with data-visible set to true

    //     addHtmlBlock(parent);
    // } else {
    //     // No qty blocks with data-visible set to true

    // }
    $(parent.find(`.cw-product-bundle__product-qty`)).attr('data-qty-id', variant_id);
    $(parent.find(`.cw-product-bundle__input-qty`)).attr('data-var-price', withoutMoneyPrice);
    //$(parent.find(`.cw-product-bundle__input-qty`)).attr('data-pro-price', withoutMoneyPrice);
    calculateTotal();
    // if (is_available == 'true') {
    //     $(parent.find(`.cw-product-bundle__btn-add`)).text('add');
    //     $(parent.find(`.cw-product-bundle__btn-add`)).css('pointer-events', 'all');
    //     $(parent.find(`.cw-product-bundle__btn-add`)).css('opacity', '1');
    // } else {
    //     $(parent.find(`.cw-product-bundle__btn-add`)).text('sold out');
    //     $(parent.find(`.cw-product-bundle__btn-add`)).css('pointer-events', 'none');
    //     $(parent.find(`.cw-product-bundle__btn-add`)).css('opacity', '0.5');
    // }


    applyImageFilterOnLoad();
    parent.find(".cw-product-bundle__product-image-slider").each(function() {
        var $slider = $(this);
        setTimeout(function() {
            $slider.slick("slickGoTo", 0);
        }, 50);
    });
});




$(document).on('click', '.cw-product-bundle__add-to-bag', function(e) {

    e.preventDefault();
    let itemsArray = [];
    var current_time = Date.now();
    let bundlePercentage = 0;
    let discountCode;
    var priceInCents = formattedPrice * 100; // Multiply if formattedPrice is in dollars and you need to convert to cents
    let cartCurrencySymbol = $('#bundle-builder').attr('data-cart-currency');
    
    // Format the price in the store's currency format
    var bundleOrignalTotal = Shopify.formatMoney(priceInCents, $('body').attr('data-money-format'));

    let tenDisPercentage = $('.js_discountPrice_1').attr("data-dis-percentage");
    let fifteenDisPercentage = $('.js_discountPrice_2').attr("data-dis-percentage");
    let twentyDisPercentage = $('.js_discountPrice_3').attr("data-dis-percentage");
    let tenDisCodeUk = $('#bundle-builder').attr('data-ten-dis-code-uk');
    let fifteenDisCodeUk = $('#bundle-builder').attr('data-fifteen-dis-code-uk');
    let twentyDisCodeUk = $('#bundle-builder').attr('data-twenty-dis-code-uk');
    let tenDisCodeUs = $('#bundle-builder').attr('data-ten-dis-code-us');
    let fifteenDisCodeUs = $('#bundle-builder').attr('data-fifteen-dis-code-us');
    let twentyDisCodeUs = $('#bundle-builder').attr('data-thirty-dis-code-us');
    let tenDisCodeEu = $('#bundle-builder').attr('data-ten-dis-code-eu');
    let fifteenDisCodeEu = $('#bundle-builder').attr('data-fifteen-dis-code-eu');
    let twentyDisCodeEu = $('#bundle-builder').attr('data-twenty-dis-code-eu');
    
    if(cartCurrencySymbol == 'USD'){
    console.log(formattedPrice);
    console.log(freeShipingThreshold1)
        if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold2) {
            bundlePercentage = tenDisPercentage;
            discountCode = tenDisCodeUs;
        } else if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold3) {
            bundlePercentage = fifteenDisPercentage;
            discountCode = fifteenDisCodeUs;
        } else if (formattedPrice >= freeShipingThreshold3) {
            bundlePercentage = twentyDisPercentage;
            discountCode = twentyDisCodeUs;
        }
    }else if(cartCurrencySymbol == 'EUR'){
        if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold2) {
            bundlePercentage = tenDisPercentage;
            discountCode = tenDisCodeEu;
        } else if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold3) {
            bundlePercentage = fifteenDisPercentage;
            discountCode = fifteenDisCodeEu;
        } else if (formattedPrice >= freeShipingThreshold3) {
            bundlePercentage = twentyDisPercentage;
            discountCode = twentyDisCodeEu;
        }
    }
    else{
    if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold2) {
        bundlePercentage = tenDisPercentage;
        discountCode = tenDisCodeUk;
    } else if (formattedPrice >= freeShipingThreshold1 && formattedPrice < freeShipingThreshold3) {
        bundlePercentage = fifteenDisPercentage;
        discountCode = fifteenDisCodeUk;
    } else if (formattedPrice >= freeShipingThreshold3) {
        bundlePercentage = twentyDisPercentage;
        discountCode = twentyDisCodeUk;
    }
}

    $('.js_product_box').each(function() {
        let productId = $(this).data('var-id'); // Get product ID
        let quantity = $(this).find('.js_qtybox').val(); // Get quantity from input
        let bundleImage = $('.cw-product-bundle__add-to-bag').data('bundle-image');
        let properties = {
            'Bundle': 'product_bundle',
            '_Bundle_price': formattedPrice,
            '_bundle_time': current_time,
            '_bundle_image': bundleImage

        };

        // if (bundlePercentage !== 0) {
        //     properties['Bundle_discount'] = bundlePercentage; // Only add this if bundlePercentage is not 0
        // }
        var addbundle = {
            id: productId,
            quantity: quantity,
            properties: properties
        };
        itemsArray.push(addbundle);
    });

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            items: itemsArray
        },
        success: function() {
            $.ajax({
                type: 'GET',
                url: '/discount/' + discountCode,
                success: function(discountResponse) {
                    $('#cart-drawer').click().trigger("click");
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                    $('.js_cart .sr-only').click();
                    $('.loading-spinner').remove();
                },
                error: function(xhr, status, error) {
                    console.error('Error applying discount:', error);
                }
            });

            totalQtyCount();
            addGiftProduct();
            console.log("ADDED");
        },
        error: function() {
          $('.loading-spinner').remove();
            // Error occurred
            //  alert('Error adding product to cart.');
        }
    });
});

function applyImageFilterOnLoad() {

    let parents = $('.eq-bundle--parent:not(.eq-bundle--parent--single)');

    // Iterate through each parent
    parents.each(function() {
        let parent = $(this);
        let filter = parent.find('select.actual-variantss option:selected').attr('data-var-title');

        parent.find(".cw-product-bundle__product-image-slider").each(function() {
            let $slider = $(this);
            $slider.slick('slickUnfilter');
            if (filter) {
                $slider.slick('slickFilter', function() {
                    let altText = $(this).find('img').closest('.cw-product-gallery__thumbnail').attr('data-alt');
                    return altText === "all" || altText === filter; // Match "all" or the selected filter
                });


                // setTimeout(function() {
                //     $slider.slick("slickGoTo", 0);
                // }, 500);
            }
        });
    });
}

$(document).ready(function() {
    addTobagDisbled();
    totalQtyCount();
    defaultShowDisPrice();
    applyImageFilterOnLoad();
});